// Language selection and application.
import { TOUCH } from '../game/input.js';
import { STOPS } from '../data/stops.js';
import { I18N } from '../data/i18n.js';
import { renderChapters } from '../game/stop-markers.js';
import { openStop } from '../game/stop-panel.js';
import { trafficLevel } from './traffic-toggle.js';
import { setFullscreenLabel } from './fullscreen.js';
import { state } from '../core/state.js';
import { bDay, bLang, bNight, bReset, bTraffic, chapters, hint, introSub } from '../dom.js';

export let tr, loc, applyLang;

export function buildLang() {
  applyLang = function applyLang() {
    bDay.textContent = tr('day');
    bNight.textContent = tr('night');
    bReset.textContent = tr('reset');
    bReset.title = tr('resetTitle');
    setFullscreenLabel();
    bLang.textContent = tr('other');
    bLang.title = tr('otherTitle');
    document.documentElement.lang = state.lang;
    if (window.trafficReady)
      bTraffic.textContent = tr('traffic') + ': ' + tr('traffic_' + trafficLevel);
    introSub.textContent = tr('introSub');
    hint.textContent = tr(
      state.mode === 'ride' ? 'ride' : state.mode === 'intro' ? 'hint' : 'orbit',
    );
    STOPS.forEach((st) => {
      if (st.label) st.label.querySelector('small').textContent = loc(st).k;
    });
    if (typeof renderChapters === 'function' && chapters.innerHTML) renderChapters();
    if (state.panelOpen && state.openIdx >= 0) openStop(state.openIdx);
  };
  try {
    state.lang =
      localStorage.getItem('lang') === 'en'
        ? 'en'
        : localStorage.getItem('lang')
          ? 'es'
          : navigator.language.startsWith('es')
            ? 'es'
            : 'en';
  } catch (e) {}
  const TAG_EN = {
    Producto: 'Product',
    Liderazgo: 'Leadership',
    Arquitectura: 'Architecture',
    'Agentes de IA': 'AI agents',
    Prototipado: 'Prototyping',
    Mentoría: 'Mentoring',
    Integraciones: 'Integrations',
    Automatización: 'Automation',
  };
  tr = (k) => (TOUCH && I18N[state.lang][k + 'Touch']) || I18N[state.lang][k];
  loc = (st) =>
    state.lang === 'en'
      ? Object.assign({}, st, st.en, { tags: st.tags.map((t) => TAG_EN[t] || t) })
      : st;
  state.openIdx = -1;
  bLang.onclick = () => {
    state.lang = state.lang === 'es' ? 'en' : 'es';
    try {
      localStorage.setItem('lang', state.lang);
    } catch (e) {}
    applyLang();
    bLang.blur();
  };
  // the loading screen's own ES/EN button
  window.setGameLang = (l) => {
    state.lang = l;
    applyLang();
  };
}
